import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateService } from '@ngx-translate/core';
import { DrawerSelectEvent } from '@progress/kendo-angular-layout';

import { environment } from '../environments/environment';
import { AuthenticationService } from './auth/authentication.service';
import { menuItemsConst } from './components/header/drawer.menu-items';
import { MenuItemModel } from './models/menu/menu-item.model';
import { MenuItems } from './models/menu/menu-items';
import { footerItemsConst } from './models/navigation/footer-items';
import { FooterModel } from './models/navigation/footer.model';
import { LocalStorageService } from './services/local-storage.service';
import { CustomMessagesService } from './services/translation/custom-messages.service';
import { Constants } from './util/constants';
import { cloneObject } from './util/utils';

@UntilDestroy()
@Component({
    selector: 'clfl-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    private menuItems!: MenuItems;
    private itemIndex!: number;

    public isAuthenticated = true;
    public items!: Array<MenuItemModel>;
    public navItemsBottom!: Array<FooterModel>;
    public localeId!: string;
    public footerText =
        'CloudFlow Evidence v' +
        environment.version +
        (environment['type'] ? '-' + environment['type'] : '') +
        ' | (C) Copyright GITS 2023';

    constructor(
        private router: Router,
        public customMsgService: CustomMessagesService,
        private translate: TranslateService,
        private localStorageService: LocalStorageService,
        public authService: AuthenticationService
    ) {
        if (this.authService.currentUserValue) {
            const userLanguage = this.localStorageService.retrieveUserLanguage(this.authService.currentUserValue.userResource.id);

            if (userLanguage) {
                this.translate.setDefaultLang(userLanguage);
            }
        }

        this.translate.setDefaultLang(Constants.LOCALE_DEFAULT_LANG);
    }

    ngOnInit() {
        this.customMsgService.sharedLanguage.pipe(untilDestroyed(this)).subscribe((language) => (this.localeId = language));
        this.displayMenu();
    }

    public onSelect(ev: DrawerSelectEvent): void {
        if (ev.item.routerLink) {
            this.router.navigate([ev.item.routerLink]);
        }
        const item = this.items.find((e: { id: any }, index: any) => {
            this.itemIndex = index;

            return e.id === ev.item.id;
        });
        item.expanded ? (item.expanded = false) : (item.expanded = true);
        if (ev.item.id && ev.item.children) {
            type objectKey = keyof typeof this.menuItems;
            const property = ev.item.id as objectKey;
            item.expanded ? this.addChildren(this.menuItems[property]) : this.removeChildren(this.menuItems[property]);
        }
    }

    public addChildren(children: Array<MenuItemModel>) {
        this.items.splice(this.itemIndex + 1, 0, ...children);
    }

    public removeChildren(children: Array<MenuItemModel>) {
        this.items.splice(this.itemIndex + 1, children.length);
    }

    private displayMenu() {
        this.menuItems = cloneObject(menuItemsConst);
        this.items = this.menuItems.parents;
        this.navItemsBottom = cloneObject(footerItemsConst);
    }
}
